var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"nudge-bottom":"40","nudge-left":"40"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticStyle:{"text-decoration":"none"},attrs:{"icon":"","href":_vm.url,"color":_vm.btnColor,"target":"_blank"}},on),[_c('v-icon',[_vm._v("mdi-chat-outline")])],1)]}}])},[_vm._v(" Feedback ")])}
var staticRenderFns = []

export { render, staticRenderFns }